(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/views/single-rows/single-match.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/views/single-rows/single-match.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.tipset.views.SingleMatch = Backbone.Marionette.View.extend({
    tagName: 'li',

    template: function(data) {
      return svs.tipset.templates.single_match(data);
    }
  });
})(Backbone, _, svs);

 })(window);